/*@flow*/
import * as t from 'lib/t';
import * as loaders from 'queries/loaders';
import Section from './templates/Section';
import AsyncTemplate from './templates/AsyncTemplate';
import isEmbedded from 'lib/isEmbedded';
import TagsTemplate from './templates/Tags';

const config = {
  contactType: t.enums({}).options({
    legend: 'Contact Type',
    nullOption: false,
    template: AsyncTemplate,
    classNamePrefix: 'SelectContactType',
    className: 'contact-contactType-select-field',
    loadValues: (o) => loaders.contactTypeLoader(o),
  }),
  tags: t.list(t.String).opt({
    label: 'Tags',
    template: TagsTemplate,
    filterName: 'contacts',
    hideWhen: isEmbedded,
  }),
};

export default t.struct(config).opt<any>({
  iconClass: 'fa-users',
  template: Section,
});
